import React from "react";
import PropTypes from "prop-types";

export const SCOPE_SERIES_ONLY = "series_only";
export const SCOPE_ALL_SHOWS = "all_shows";
export const SCOPE_SELECTED = "selected";

// Same shape as the date list in the "Make recurring" modal, rather than a second
// way of picking shows in the same product.
const ShowScopeChooser = ({
  scope,
  onScopeChange,
  name,
  groupLabel,
  shows,
  venueTimeZone,
  selectedIds,
  onToggle,
  seriesOnlyLabel,
  allLabel,
}) => (
  <>
    <div className="series-scope-chooser" role="radiogroup" aria-label={groupLabel}>
      {seriesOnlyLabel && (
        <label className="series-scope-option">
          <input
            type="radio"
            name={name}
            checked={scope === SCOPE_SERIES_ONLY}
            onChange={() => onScopeChange(SCOPE_SERIES_ONLY)}
          />
          <span>{seriesOnlyLabel}</span>
        </label>
      )}
      <label className="series-scope-option">
        <input
          type="radio"
          name={name}
          checked={scope === SCOPE_ALL_SHOWS}
          onChange={() => onScopeChange(SCOPE_ALL_SHOWS)}
        />
        <span>{allLabel}</span>
      </label>
      <label className="series-scope-option">
        <input
          type="radio"
          name={name}
          checked={scope === SCOPE_SELECTED}
          onChange={() => onScopeChange(SCOPE_SELECTED)}
        />
        <span>{`Choose which shows to cancel (${shows.length} available)`}</span>
      </label>
    </div>
    {scope === SCOPE_SELECTED && (
      <ul className="series-scope-shows">
        {shows.map((show) => {
          // Dated in the venue's zone, not the reader's — same rule the schedule
          // rows follow, so the picker can't show a different night to the table.
          const dateLabel = new Date(show.start_time).toLocaleDateString("en-US", {
            month: "short",
            day: "numeric",
            year: "numeric",
            ...(venueTimeZone ? { timeZone: venueTimeZone } : {}),
          });
          return (
            <li key={show.calendar_event_id}>
              <label className="series-scope-show-row">
                <input
                  type="checkbox"
                  checked={selectedIds.has(show.calendar_event_id)}
                  onChange={() => onToggle(show.calendar_event_id)}
                />
                <span className="series-scope-show-name" title={show.name || show.weekday}>
                  {show.name || show.weekday}
                </span>
                <span className="series-scope-show-date">{dateLabel}</span>
              </label>
            </li>
          );
        })}
      </ul>
    )}
  </>
);

ShowScopeChooser.propTypes = {
  scope: PropTypes.string.isRequired,
  onScopeChange: PropTypes.func.isRequired,
  name: PropTypes.string.isRequired,
  groupLabel: PropTypes.string.isRequired,
  shows: PropTypes.array.isRequired,
  venueTimeZone: PropTypes.string,
  selectedIds: PropTypes.object.isRequired,
  onToggle: PropTypes.func.isRequired,
  seriesOnlyLabel: PropTypes.string,
  allLabel: PropTypes.string.isRequired,
};

export default ShowScopeChooser;
